// extracted by mini-css-extract-plugin
export default {"card":"TZ-z","carouselContainer":"UZ-z","carouselContent":"VZ-z"};